import React, { FC } from 'react'

import { getStyledElementProps } from '@/utils'
import { Checkbox, Typography } from '@/atoms'
import { CheckboxLabeledProps } from '@/types'

import styles from './checkbox-labeled.module.scss'

export const CheckboxLabeled: FC<CheckboxLabeledProps> = ({
  label,
  name,
  multiple,
  checked,
  onChange,
  onBlur,
  value = '',
  labelProps = {},
  checkboxProps = {},
  spanProps = {},
  backgroundColor,
  checkColor = 'transparent',
}) => {
  const styledLabelProps = getStyledElementProps(labelProps, styles['label'])

  return (
    <label {...styledLabelProps}>
      <Checkbox
        name={name}
        value={value}
        multiple={multiple}
        checked={checked}
        onChange={onChange}
        onBlur={onBlur}
        {...checkboxProps}
        backgroundColor={backgroundColor}
        checkColor={checkColor}
      />
      <Typography variant={'body-1'} tag={'span'} {...spanProps}>
        {label}
      </Typography>
    </label>
  )
}
